module.exports = __webpack_public_path__ + "img/eye-icon.9fa613ec.svg";